var viewer_rtlignore_default = {
  "gallery_container": "Wbsoa",
  "imageTitleContainer": "sqw7M",
  "clickableItem": "LZjEn",
  "prerender": "jwt6a",
  "expandContainer": "kFgBL",
  "expandIcon": "_7fiTK",
  "itemOverlay": "Z7vGi",
  "imageTitle": "VmOAg",
  "pointer": "HbL91",
  "fadeIn": "DjEId",
  "changing_background": "RbLE-"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
